<template>
  <div class="text-options-data-dialog">
    <el-collapse v-model="activeNames">
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '1')" title="数据源" name="1">
        <div class="content-item">
          <!-- <div class="dataSource-item" @click="goToChooseData">
            <span>进入数据管理后台 </span>
          </div> -->
          <data-center-choose 
            :checkStatus="checkStatus"
            :myId="ids"
            :options="options"
            @onDataCenterChange="onDataCenterChange"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '2')" title="逻辑配置" name="2">
        <div
          v-for="(specialConditionItem, index) in specialCondition"
          :key="index"
          class="content-item mb16 conditionListContent"
        >
          <div class="delete-btn" @click="deleteSpecialConditionHandle(index)">
            <span class="icon-portal-delete1"></span>
          </div>
          <div class="data-item flex">
            <span class="icon-portal-variable-data fs16 mr8"></span>
            <span>满足以下条件</span>
          </div>
          <div class="dynamic_color_bg">
            <div class="data-item mb8">
              <el-select
                style="width: 188px; height: 28px"
                v-model="specialConditionItem.variableValue"
                @change="getSpecialConditionVariableHandle($event, index)"
              >
                <el-option
                  v-for="variableDataItem in variableDataList"
                  :key="variableDataItem.variableValue"
                  :label="variableDataItem.variableLabel"
                  :value="variableDataItem.variableValue"
                >
                  {{ variableDataItem.variableLabel }}
                </el-option>
              </el-select>
            </div>
            <div class="data-item mb8">
              <el-select
                style="width: 188px; height: 28px"
                v-model="specialConditionItem.condition"
                @change="getSpecialConditionTypeHandle($event, index)"
              >
                <el-option
                  v-for="conditionTypeItem in conditionTypeList"
                  :key="conditionTypeItem.value"
                  :label="conditionTypeItem.label"
                  :value="conditionTypeItem.value"
                >
                  {{ conditionTypeItem.label }}
                </el-option>
              </el-select>
            </div>
            <div
              class="data-item"
              v-if="specialConditionItem.condition !== '为空' && specialConditionItem.condition !== '不为空'"
            >
              <el-input
                style="width: 188px"
                v-model="specialConditionItem.parameter"
                @change="getSpecialConditionParameterHandle($event, index)"
                placeholder="参数值"
              ></el-input>
            </div>
          </div>
          <div class="data-item mb8 flex">
            <span class="icon-portal-preview-hidden fs16 mr8"></span>
            <span v-if="specialConditionItem.type == 'hiddenRow'"> 预览时，隐藏所在行</span>
            <span v-else> 预览时，隐藏所在页</span>
          </div>
        </div>
        <div class="addSpecalConditionBtn" @click="addSpecialConditionHandle('hiddenPage')">
          <span class="icon-portal-plus mr2"></span>
          <span class="">添加隐藏页条件</span>
        </div>
        <div class="addSpecalConditionBtn" @click="addSpecialConditionHandle('hiddenRow')">
          <span class="icon-portal-plus mr2"></span>
          <span class="">添加隐藏行条件</span>
        </div>
      </el-collapse-item>
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '3')" title="更多" name="3">
        <div class="content-item">
          <auto-update-timer :isLocal="false"/>
          <!-- <div class="getDataBtn" @click="getBaseModuleDataLoop()">保存配置</div> -->
        </div>
        <div class="content-item" v-for="(variableDataItem, index) in variableDataList" :key="index">
          <collapsibleItem>
            <div slot="heading" :id="variableDataItem.variableValue + '-setting'">
              {{ variableDataItem.variableLabel }}
              <span
                class="variable-delete-btn icon-portal-delete1"
                @click="deleteVariableHandle(variableDataItem.variableValue)"
              ></span>
            </div>
            <div slot="body">
              <collapsibleItem>
                <div slot="heading" :id="variableDataItem.variableValue + '-setting-data'">数据设置</div>
                <div slot="body">
                  <div class="data-item mb8">
                    <div class="mb8">变量内容</div>
                    <el-select
                      style="width: 188px; height: 28px"
                      v-model="variableDataItem.field"
                      @change="getDynamicDataFieldHandle(index, $event)"
                      placeholder="请选择字段"
                    >
                      <el-option
                        v-for="fieldItem in fieldList"
                        :key="fieldItem.label"
                        :label="fieldItem.label"
                        :value="fieldItem.label"
                      >
                        {{ fieldItem.label }}
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </collapsibleItem>
              <collapsibleItem>
                <div slot="heading">条件设置</div>
                <div slot="body">
                  <div
                    v-for="(conditionItem, index1) in variableDataItem.conditionList"
                    :key="index1"
                    class="content-item mb16 conditionListContent"
                  >
                    <div class="delete-btn" @click="deleteDynamicDataHandle(index, index1)">
                      <span class="icon-portal-delete1"></span>
                    </div>
                    <div class="mb8">
                      <el-radio-group
                        v-model="conditionItem.type"
                        @change="getDynamicDataTypeHandle(index, index1, $event)"
                      >
                        <el-radio label="singleValue">单值判断</el-radio>
                        <el-radio label="range">区间范围</el-radio>
                      </el-radio-group>
                    </div>
                    <div class="data-item flex mb8">
                      <span class="icon-portal-variable-data fs16 mr8"></span>
                      <span>{{ variableDataItem.variableLabel }}</span>
                    </div>
                    <div v-if="conditionItem.type === 'singleValue'" class="dynamic_color_bg">
                      <div class="data-item mb8">
                        <el-select
                          style="height: 28px"
                          v-model="conditionItem.condition"
                          @change="getDynamicDataConditionTypeHandle(index, index1, $event)"
                        >
                          <el-option
                            v-for="conditionTypeItem in conditionTypeList"
                            :key="conditionTypeItem.value"
                            :label="conditionTypeItem.label"
                            :value="conditionTypeItem.value"
                          >
                            {{ conditionTypeItem.label }}
                          </el-option>
                        </el-select>
                      </div>
                      <div
                        class="data-item"
                        v-if="conditionItem.condition !== '为空' && conditionItem.condition !== '不为空'"
                      >
                        <el-input
                          v-model="conditionItem.parameter"
                          @change="getDynamicDataParameterHandle(index, index1, $event)"
                          placeholder="参数值"
                        ></el-input>
                      </div>
                    </div>
                    <div v-if="conditionItem.type === 'range'" class="dynamic_color_bg">
                      <single-input
                        @change="getDynamicDataConditionRange1Handle(index, index1, $event, 0)"
                        style="width: 65.5px; height: 32px"
                        :value.sync="conditionItem.conditionRange[0]"
                        :noInputSuffixs="true"
                      />
                      <span> <= 值 < </span>
                      <single-input
                        @change="getDynamicDataConditionRange1Handle(index, index1, $event, 1)"
                        style="width: 65.5px; height: 32px"
                        :value.sync="conditionItem.conditionRange[1]"
                        :noInputSuffixs="true"
                      />
                    </div>
                    <div class="data-item mb8 flex">
                      <span class="icon-portal-dynamic-data1 fs16 mr8"></span>
                      <el-select
                        style="width: 188px; height: 28px"
                        v-model="conditionItem.dynamicValue"
                        @change="getDynamicDataValueHandle(index, index1, $event)"
                      >
                        <el-option
                          v-for="(dynamicItem, index3) in dynamicList"
                          :key="index3"
                          :label="dynamicItem.label"
                          :value="dynamicItem.value"
                        >
                          {{ dynamicItem.label }}
                        </el-option>
                      </el-select>
                    </div>
                    <div class="data-item mb8 ml24">
                      <div class="font14 mb8">显示的内容为</div>
                      <div
                        class="result-content"
                        contenteditable="true"
                        v-html="formatAstToDom(conditionItem.result)"
                        @blur="getDynamicDataResultHandle($event, index, index1)"
                      ></div>
                    </div>
                  </div>
                  <div class="addConditionBtn" @click="addDynamicDataHandle(index)">
                    <span class="icon-portal-plus mr2"></span>
                    <span class="">添加条件</span>
                  </div>
                </div>
              </collapsibleItem>
            </div>
          </collapsibleItem>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import CollapsibleItem from "modules/components/collapsibleItem"
import { parseDOM, parseAST } from "utils/parseDomAst/index"
import autoUpdateTimer from "components/toolbar-option-components/utilsComponents/autoUpdateTimer/autoUpdateTimer.vue"
import dataCenterChoose from "publicSetting/dataCenterChoose.vue"
export default {
  name: "text-options-data",
  components: { CollapsibleItem, autoUpdateTimer, dataCenterChoose },
  props: {
    options: {
      type: Object
    }
  },
  data() {
    return {
      this1: this,
      labelTrue: true,
      labelFalse: false,
      activeNames: ["1"],
      collapseActiveNames: [],
      linkAddress: "无",
      conditionTypeList: [
        {
          value: "等于",
          label: "等于"
        },
        {
          value: "不等于",
          label: "不等于"
        },
        {
          value: "包含",
          label: "包含"
        },
        {
          value: "不包含",
          label: "不包含"
        },
        {
          value: "大于",
          label: "大于"
        },
        {
          value: "小于",
          label: "小于"
        },
        {
          value: "为空",
          label: "为空"
        },
        {
          value: "不为空",
          label: "不为空"
        }
      ],
      conditionTypeSelected: "等于",
      dynamicSelected: "",
      variableValue: "",
      variableList: [],
      fetchEnd: false
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    restDataUrl: {
      get() {
        return this.options.restDataUrl
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "restDataUrl", false)
      }
    },
    fieldList: {
      get() {
        return this.options.fieldList
      }
    },
    variableDataList: {
      get() {
        // 数据兼容处理，以前条件判断只有单值判断，现在增加范围判断，需要加入两个参数
        let flag = false
        const temp = JSON.parse(JSON.stringify(this.options.variableDataList))
        for (let i = 0; i < temp.length; i++) {
          const conditionListTemp = temp[i].conditionList
          for (let j = 0; j < conditionListTemp.length; j++) {
            if (!conditionListTemp[j].type) {
              temp[i].conditionList[j].type = "singleValue"
              flag = true
            }
            if (!conditionListTemp[j].conditionRange) {
              temp[i].conditionList[j].conditionRange = [0, 10]
              flag = true
            }
          }
        }
        if (flag) this.$changeOptionsEV(temp, "variableDataList", false)
        return this.options.variableDataList
      }
    },
    specialCondition: {
      get() {
        if (!this.options.specialCondition) {
          this.$changeOptionsEV([], "specialCondition", false)
        }
        return this.options.specialCondition
      }
    },
    dynamicList: {
      get() {
        return this.options.dynamicList
      }
    },
    checkStatus() {
      return this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
    }
  },
  mounted() {
    this.$eventBus.$on("update-toolbar-data", this.updateToolbarData)
  },
  beforeDestroy() {
    this.$eventBus.$off("update-toolbar-data", this.updateToolbarData)
  },
  methods: {
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    goToChooseData() {
      if (this.fetchEnd) return
      this.fetchEnd = true
      const { websiteId, pageId, sign, wfwfid, homePageId, pageType } = this.$store.state.states.getDataPageIds
      const rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids)
      let { moduleId, appId } = rectAttr
      if (moduleId === undefined) moduleId = rectAttr?.options?.moduleId
      if (rectAttr?.options?.appId !== undefined) appId = rectAttr?.options?.appId
      if (!!!moduleId || !!!appId) {
        this.$saveModule(this.ids, "31CB73E03E24BBFF", "临时")
          .then(res => {
            this.fetchEnd = false
            if (!!res.appId) {
              window.open(`/engine2/data/api-v2/admin/general/${res.appId}?w=${websiteId}&p=${pageId}&init=1`)
            }
          })
          .catch(err => (this.fetchEnd = false))
      }
      this.fetchEnd = false
      if (!!appId) window.open(`/engine2/data/api-v2/admin/general/${appId}?w=${websiteId}&p=${pageId}`)
    },
    async getBaseModuleDataLoop() {
      if (!this.checkStatus) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "error",
          message: "请进入数据管理后台添加数据"
        })
        return
      }
      this.updateNormalRect
        .call(this, datas => {
          this.content = datas[0][Object.keys(datas[0])[0]].value
          const data = datas[0]
          let fieldList = []
          Object.keys(data).map((key, item) => {
            console.log(key, data[key])
            if (Object.prototype.toString.call(data[key]) === "[object Object]") {
              // 判断是否为Object
              const param = {
                label: data[key].key,
                value: data[key].value
              }
              fieldList.push(param)
            }
          })
          this.$changeOptionsEV(fieldList, "fieldList", false)
        })
        .then(restDataUrl => {
          this.restDataUrl = restDataUrl
        })
    },
    // 添加动态数据条件点击事件
    addDynamicDataHandle(index) {
      let condition = {
        condition: "等于", // 条件  等于；不等于；包含；不包含；大于；小于
        dynamicLabel: "", // 动态数据名
        dynamicValue: "", // 动态数据唯一标识
        parameter: "", // 参数值
        result: "" // 结果
      }
      let variableDataListTemp = JSON.parse(JSON.stringify(this.options.variableDataList))
      variableDataListTemp[index].conditionList.push(condition)
      this.$changeOptionsEV(variableDataListTemp, "variableDataList", false)
    },
    // 删除动态数据条件点击事件
    deleteDynamicDataHandle(index, index1) {
      let variableDataListTemp = JSON.parse(JSON.stringify(this.options.variableDataList))
      variableDataListTemp[index].conditionList.splice(index1, 1)
      this.$changeOptionsEV(variableDataListTemp, "variableDataList", false)
    },
    // 动态数据切换条件设置
    getDynamicDataTypeHandle(index, index1, $event) {
      let variableDataListTemp = JSON.parse(JSON.stringify(this.options.variableDataList))
      variableDataListTemp[index].conditionList[index1].type = $event
      this.$changeOptionsEV(variableDataListTemp, "variableDataList", false)
    },
    // 排序表格动态数据改变条件范围1
    getDynamicDataConditionRange1Handle(index, index1, $event, index2) {
      let variableDataListTemp = JSON.parse(JSON.stringify(this.options.variableDataList))
      variableDataListTemp[index].conditionList[index1].conditionRange[index2] = $event
      this.$changeOptionsEV(variableDataListTemp, "variableDataList", false)
    },
    // 排序表格动态数据改变条件范围2
    getDynamicDataConditionRange2Handle(index, $event) {
      let variableDataListTemp = JSON.parse(JSON.stringify(this.options.variableDataList))
      variableDataListTemp[index].conditionList[index1].conditionRange[1] = $event
      this.$changeOptionsEV(variableDataListTemp, "variableDataList", false)
    },
    // 改变字段名称
    getDynamicDataFieldHandle(index, $event) {
      let variableDataListTemp = JSON.parse(JSON.stringify(this.options.variableDataList))
      variableDataListTemp[index].field = $event
      this.$changeOptionsEV(variableDataListTemp, "variableDataList", false)
    },
    // 改变条件
    getDynamicDataConditionTypeHandle(index, index1, $event) {
      let variableDataListTemp = JSON.parse(JSON.stringify(this.options.variableDataList))
      variableDataListTemp[index].conditionList[index1].condition = $event
      this.$changeOptionsEV(variableDataListTemp, "variableDataList", false)
    },
    // 改变绑定动态数据值
    getDynamicDataValueHandle(index, index1, $event) {
      let variableDataListTemp = JSON.parse(JSON.stringify(this.options.variableDataList))
      const dynamicLabel = this.options.dynamicList.filter(item => item.value === $event)[0].label
      variableDataListTemp[index].conditionList[index1].dynamicValue = $event
      variableDataListTemp[index].conditionList[index1].dynamicLabel = dynamicLabel
      this.$changeOptionsEV(variableDataListTemp, "variableDataList", false)
    },
    // 改变参数值
    getDynamicDataParameterHandle(index, index1, $event) {
      let variableDataListTemp = JSON.parse(JSON.stringify(this.options.variableDataList))
      variableDataListTemp[index].conditionList[index1].parameter = $event
      this.$changeOptionsEV(variableDataListTemp, "variableDataList", false)
    },
    // 改变结果
    getDynamicDataResultHandle($event, index, index1) {
      let variableDataListTemp = JSON.parse(JSON.stringify(this.options.variableDataList))
      console.log("in", $event.currentTarget.innerHTML)
      if (!!$event.currentTarget.innerHTML) {
        const ast = parseAST(`<div class="condition_result">${$event.currentTarget.innerHTML}</div>`)
        variableDataListTemp[index].conditionList[index1].result = ast
        this.$changeOptionsEV(variableDataListTemp, "variableDataList", false)
      }
    },
    // 修改特殊条件中的变量
    getSpecialConditionVariableHandle($event, index) {
      let specialConditionTemp = JSON.parse(JSON.stringify(this.options.specialCondition))
      specialConditionTemp[index].variableValue = $event
      this.$changeOptionsEV(specialConditionTemp, "specialCondition", false)
    },
    // 修改特殊条件中的条件
    getSpecialConditionTypeHandle($event, index) {
      let specialConditionTemp = JSON.parse(JSON.stringify(this.options.specialCondition))
      specialConditionTemp[index].condition = $event
      this.$changeOptionsEV(specialConditionTemp, "specialCondition", false)
    },
    // 修改特殊条件中的参数值
    getSpecialConditionParameterHandle($event, index) {
      let specialConditionTemp = JSON.parse(JSON.stringify(this.options.specialCondition))
      specialConditionTemp[index].parameter = $event
      this.$changeOptionsEV(specialConditionTemp, "specialCondition", false)
    },
    // 删除特殊条件
    deleteSpecialConditionHandle(index) {
      let specialConditionTemp = JSON.parse(JSON.stringify(this.options.specialCondition))
      specialConditionTemp.splice(index, 1)
      this.$changeOptionsEV(specialConditionTemp, "specialCondition", false)
    },
    // 新增特殊条件
    addSpecialConditionHandle(type) {
      let specialCondition = JSON.parse(JSON.stringify(this.options.specialCondition))
      const specialConditionTemp = {
        field: "", // 字段名称
        variableLabel: "", // 变量名
        variableValue: "", // 变量唯一标识
        condition: "等于", // 条件  等于；不等于；包含；不包含；大于；小于
        parameter: "", // 参数值
        type: type // 隐藏页或隐藏行
      }
      specialCondition.push(specialConditionTemp)
      this.$changeOptionsEV(specialCondition, "specialCondition", false)
    },
    // 将ast转换成dom
    formatAstToDom(ast) {
      if (!!ast) {
        const dom = parseDOM(ast)
        return dom.innerHTML
      }
    },
    // 删除变量
    deleteVariableHandle(id) {
      let variableDataListTemp = JSON.parse(JSON.stringify(this.options.variableDataList))
      variableDataListTemp = variableDataListTemp.filter(item => item.variableValue !== id)
      this.$changeOptionsEV(variableDataListTemp, "variableDataList", false)
      const replaceNode = document.getElementById(id)
      replaceNode.replaceWith(replaceNode.innerHTML)
    },
    onDataCenterChange() {
      this.getBaseModuleDataLoop()
    },
    updateToolbarData() {
      this.getBaseModuleDataLoop()
    }
  }
}
</script>

<style lang="scss" scoped>
.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  color: var(--themeColor);
  &:hover {
    cursor: pointer;
  }
}
.left-label {
  min-width: 60px;
}
.card {
  background: rgba(41, 44, 49, 1);
}
.count-limit-item::v-deep .el-input__inner {
  background: #35383f;
  padding: 0 12px;
  border-radius: 4px;
}

.setting-item .count-limit-item span {
  margin: 0 8px;
}
.setting-item .content-item .el-checkbox {
  margin-right: 20px;
}
.count-limit-item::v-deep .el-radio {
  margin-top: 7px;
  margin-bottom: 3px;
}

.count-limit-item::v-deep .el-radio:first-child {
  margin-top: 0;
}

.count-limit-item::v-deep .el-radio-group {
  width: 80px;
}
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 0px;
}
.getDataBtn:hover {
  cursor: pointer;
}
.edit-div {
  width: 100%;
  background-color: var(--inputBackGround);
  border: var(--inputBorder);
  box-sizing: border-box;
  border-radius: 4px;
  padding: 4px;
}
.edit-div:focus {
  outline: none;
  border: 1px solid var(--themeColor);
}
.conditionListContent {
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  padding: 8px;
  position: relative;
}
.conditionListContent .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  background: #e9e9e9;
  border-radius: 0px 4px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.conditionListContent .delete-btn .icon-portal-delete1 {
  top: 4.83px;
  left: 5.5px;
  position: absolute;
}
.conditionListContent .delete-btn .icon-portal-delete1:before {
  color: rgba(0, 0, 0, 0.4);
}
.addConditionBtn {
  border: 1px solid var(--themeColor);
  box-sizing: border-box;
  border-radius: 4px;
  width: 102px;
  height: 32px;
  font-size: 14px;
  line-height: 20px;
  color: var(--themeColor);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.addSpecalConditionBtn {
  border: 1px solid var(--themeColor);
  box-sizing: border-box;
  border-radius: 4px;
  width: 120px;
  height: 32px;
  font-size: 14px;
  line-height: 20px;
  color: var(--themeColor);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: 8px;
}
.variable-delete-btn {
  position: absolute;
  top: 14px;
  right: 0;
  cursor: pointer;
}
.variable_content {
  display: flex;
  align-items: center;
}
.variable-data-left {
  width: 16px;
  height: 120px;
  background: url("../../../assets/images/variable-data-left.png");
}
.dynamic_color_bg {
  padding: 8px 0 8px 16px;
  margin-left: 7.5px;
  background-clip: padding-box, border-box;
  background-origin: padding-box, border-box;
  background-image: -webkit-linear-gradient(180deg, #fff, #fff),
    linear-gradient(180deg, rgba(255, 0, 199, 1), rgba(36, 0, 255, 1));
  background-image: -moz-linear-gradient(180deg, #fff, #fff),
    linear-gradient(180deg, rgba(255, 0, 199, 1), rgba(36, 0, 255, 1));
  background-image: linear-gradient(180deg, #fff, #fff),
    linear-gradient(180deg, rgba(255, 0, 199, 1), rgba(36, 0, 255, 1));
  border-left: 1px transparent solid;
}
.result-content {
  padding: 8px 12px;
  /* width: 188px; */
  height: 80px;
  background: #f0f0f0;
  border-radius: 4px;
}
::v-deep.el-collapse-item__content {
  padding: 16px !important;
}
</style>
